import { Reveal } from "./Reveal";

export const MadeInIndia = () => {
  return (
    <section
      data-testid="made-in-india-section"
      className="relative overflow-hidden bg-aero-navy"
    >
      {/* accent top rule */}
      <div className="h-1 w-full bg-saffron" />

      <div className="blueprint-grid absolute inset-0 opacity-20" />

      <div className="relative mx-auto max-w-[1400px] px-5 py-20 sm:px-8 sm:py-24">
        <div className="grid items-center gap-12 lg:grid-cols-[auto_1fr] lg:gap-16">
          <Reveal>
            <div
              data-testid="make-in-india-logo-card"
              className="mx-auto w-fit rounded-2xl border border-steel/20 bg-white p-7 shadow-[0_16px_50px_rgba(0,0,0,0.4)] sm:p-9 lg:mx-0"
            >
              <img
                src="/make-in-india.png"
                alt="Make in India"
                data-testid="make-in-india-logo"
                className="h-20 w-auto sm:h-28"
              />
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div>
              <span className="font-heading text-xs uppercase tracking-[0.28em] text-saffron">
                National Pride
              </span>
              <h2 className="mt-4 font-heading text-4xl font-black leading-[1.05] tracking-tight text-ink sm:text-5xl">
                Proudly Made in India Since 1974.
              </h2>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
